import { useState } from 'react';
import ModalShell from './ModalShell';
import { useTranslation } from '../../hooks/useTranslation';

const MIN_PW_LENGTH = 6;

const ResetPasswordModal = ({ user, saving, onClose, onSave }) => {
  const { t } = useTranslation();
  const [newPassword, setNewPassword] = useState('');
  const [touched, setTouched] = useState(false);
  const tooShort = newPassword.length > 0 && newPassword.length < MIN_PW_LENGTH;
  const isInvalid = (touched && tooShort) || (touched && !newPassword);

  const handleSubmit = () => {
    setTouched(true);
    if (!newPassword || newPassword.length < MIN_PW_LENGTH) return;
    onSave(newPassword);
  };

  return (
    <ModalShell
      title={
        <>
          <i className="bi bi-key me-2"></i>
          {t('users.pwResetTitle', { username: user.username })}
        </>
      }
      onClose={onClose}
      footer={
        <>
          <button className="btn btn-secondary" onClick={onClose}>{t('common.cancel')}</button>
          <button className="btn btn-warning" onClick={handleSubmit} disabled={saving || !newPassword}>
            {saving ? t('common.saving') : t('users.resetPassword')}
          </button>
        </>
      }
    >
      <div className="modal-body">
        <label className="form-label" htmlFor="newPasswordInput">{t('settings.newPassword')}</label>
        <input
          id="newPasswordInput"
          type="password"
          className={`form-control ${isInvalid ? 'is-invalid' : ''}`}
          value={newPassword}
          onChange={(e) => setNewPassword(e.target.value)}
          onBlur={() => setTouched(true)}
          placeholder={t('settings.pwMinLength')}
          minLength={MIN_PW_LENGTH}
          aria-invalid={isInvalid}
        />
        {tooShort && (
          <div className="invalid-feedback d-block">{t('settings.pwMinLength')}</div>
        )}
      </div>
    </ModalShell>
  );
};

export default ResetPasswordModal;
